import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import Discount from "./tabs/discount";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import AllCustomerType from "./tabs/customerType";
import hasPermission from "@/hooks/hasPermission";

function DiscountManagement() {
  const hasDiscount = hasPermission("back_office.settings.discount");
  const hasCustomerType = hasPermission("back_office.settings.customer_type");

  const defaultTab = hasDiscount
    ? "discount"
    : hasCustomerType
    ? "customer-type"
    : "";

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "Overview" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Settings",
          path: "",
        },
        {
          name: "Discount Management",
          path: "/backoffice/settings/discount",
        },
      ]}
    >
      <div>
        <Tabs
          valueKey="discount"
          className="bg-transparent relative"
          defaultValue={defaultTab}
        >
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            {hasDiscount && (
              <TabsTrigger className="bg-transparent" value="discount">
                {" "}
                Discount{" "}
              </TabsTrigger>
            )}
            {hasCustomerType && (
              <TabsTrigger className="bg-transparent" value="customer-type">
                {" "}
                Customer Type{" "}
              </TabsTrigger>
            )}
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          {hasDiscount && <Discount />}
          {hasCustomerType && <AllCustomerType />}
        </Tabs>
      </div>
    </Layout2>
  );
}

export default DiscountManagement;
